export default {
  '@class': 'string',
  id: 'number',
  token: 'string',
  description: 'string',
  number: 'string',
}
